module.exports = __webpack_public_path__ + "media/Beauty Sings - Tatiana Manaois (Mp3Goo.io).bec8cebb.mp3";